export const GET_SELECTED_LOCATION = 'get-selected-location';
const getSelectedLocation = () => ({ type: GET_SELECTED_LOCATION });
export default getSelectedLocation;
